import { render, staticRenderFns } from "./Leads.vue?vue&type=template&id=3719634e&"
import script from "./Leads.vue?vue&type=script&lang=ts&"
export * from "./Leads.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports